import {useFlags} from "../../../../../config/featureFlags";
import {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import getPage from "../../../../../helpers/getPage.helpers";

const Terms = ({ intl }) => {
  const pageName = 'TERMS';

  const { DISPLAY_LIKUMI_CONTENT } = useFlags();
  const [content, setContent] = useState("");

  useEffect(() => {
    getPage(pageName).then((res) => res?.data?.content?.length && setContent(res?.data?.content))
  }, []);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: (DISPLAY_LIKUMI_CONTENT) ? `
          ${intl.formatMessage({ id: "LIKUMI.TERMS.TOS" })} 
        ` : content
      }}
    />
  );
};

export default injectIntl(Terms);
